
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/SavedSearches",
      function () {
        return require("private-next-pages/SavedSearches.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/SavedSearches"])
      });
    }
  